import React, { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons/faEllipsis';

// todo: refactor this component
const ActionMenu = ({ actions, icon, buttonStyle, buttonClassName = '', menuItemStyle = {} }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuPosition, setMenuPosition] = useState({});

    const menuHeight = actions.reduce((height, action) => height + (action.separator ? 13 : 42), 16);
    const menuWidth = 210;

    const computeMenuPosition = useCallback((el) => {
        if (!el) return {};
        const rect = el.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;
        const spaceBelow = viewportHeight - rect.bottom;
        const showBelow = spaceBelow >= menuHeight;
        const preferredTop = showBelow ? rect.bottom + 8 : rect.top - menuHeight - 8;
        const top = Math.max(8, Math.min(preferredTop, viewportHeight - menuHeight - 8));
        const rawLeft = rect.right - menuWidth; // align right edges
        const left = Math.max(8, Math.min(rawLeft, viewportWidth - menuWidth - 8));
        return { position: 'fixed', top, left };
    }, [menuHeight, menuWidth]);

    const handleClick = (event) => {
        const el = event.currentTarget;
        setAnchorEl(el);
        setMenuPosition(computeMenuPosition(el));
    };

    const handleClose = () => {
        setAnchorEl(null);
        setMenuPosition({});
    };

    // follow trigger on scroll/resize
    useEffect(() => {
        if (!anchorEl) return;
        const update = () => setMenuPosition(computeMenuPosition(anchorEl));
        window.addEventListener('scroll', update, true);
        window.addEventListener('resize', update);
        return () => {
            window.removeEventListener('scroll', update, true);
            window.removeEventListener('resize', update);
        };
    }, [anchorEl, computeMenuPosition]);

    return (
        <div onPointerDown={(event) => event.stopPropagation()}>
            {/* Trigger Button */}
            <button onClick={(event) => {
                event.stopPropagation();
                handleClick(event);
            }}
                className={buttonClassName}
                style={{ background: 'none', border: 'none', cursor: 'pointer', ...buttonStyle }}
                aria-haspopup="true"
                aria-expanded={Boolean(anchorEl)}
            >
                <FontAwesomeIcon icon={icon || faEllipsis} />
            </button>

            {/* Modal Overlay */}
            {anchorEl && createPortal(
                <>
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            backgroundColor: 'rgba(0, 0, 0, 0)', // Fully transparent overlay
                            zIndex: 2000,
                        }}
                        onClick={(event) => { event.stopPropagation(); handleClose(); }}
                    ></div>

                    {/* Dropdown Menu */}
                    <div
                        style={{
                            ...menuPosition,
                            backgroundColor: 'white',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                            borderRadius: '4px',
                            padding: '8px',
                            width: menuWidth,
                            boxSizing: 'border-box',
                            zIndex: 2010, // Keep the shared menu above application modals.
                        }}
                        role="menu"
                    >
                        {actions.map((action, index) => (
                            action.separator ? (
                                <div
                                    key={index}
                                    style={{
                                        height: 1,
                                        backgroundColor: '#eceff3',
                                        margin: '6px 0',
                                    }}
                                    role="separator"
                                />
                            ) : (
                                <div
                                    key={index}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        action.callback();
                                        handleClose();
                                    }}
                                    style={{
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        ...menuItemStyle,
                                    }}
                                    role="menuitem"
                                    tabIndex={0}
                                >
                                    {action.icon && (
                                        <FontAwesomeIcon icon={action.icon} style={{ marginRight: 8 }} />
                                    )}
                                    {action.label}
                                </div>
                            )
                        ))}
                    </div>
                </>,
                document.body,
            )}
        </div>
    );
};

export default ActionMenu;
